module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "co2--dataset-cover.53546d25.jpg";